import NotifyContainer from './NotifyContainer';
import notify from './notify';

export {
  NotifyContainer as default,
  notify,
};



// WEBPACK FOOTER //
// ./src/components/Notify/index.js